
import AppLayoutVue from "@/Layouts/AppLayout.vue";
import { defineComponent, PropType } from "vue";
import ProductFilter from "@/Components/Product/ProductFilter.vue";
import Card from "@/Components/General/Card.vue";
import Category from "@/types/Category";
import Product from "@/types/Product";
import ProductList from "@/Components/Product/ProductList.vue";
import Pagination from "@/types/Pagination";
import Messages from "@/Components/General/Messages.vue";
import Button from "@/Components/Buttons/Button.vue";
import { computed } from "@vue/reactivity";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiBasketOutline, mdiPercentOutline } from "@mdi/js";

export default defineComponent({
  props: {
    categories: {
      type: Object as PropType<Category[]>,
      required: true,
    },
    suppliers: {
      type: Object as PropType<Category[]>,
      required: true,
    },
    form: {
      type: Object,
      required: false,
    },
    products: {
      type: Object as PropType<Pagination<Product> | null>,
      required: false,
    },
    isAdmin: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(props) {
    const addProductLink = computed(() => {
      return "/l-products/new-product/";
    });

    const bulkSaleLink = computed(() => {
      return "/l-products/add-bulk-discount/";
    });

    return {
      addProductLink,
      bulkSaleLink,
      saleIcon: mdiPercentOutline,
      newProductIcon: mdiBasketOutline,
    };
  },
  layout: AppLayoutVue,
  components: { ProductFilter, Card, ProductList, Messages, Button, SvgIcon },
});
